import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73441d93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Каталог", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_CategoriesSideBar = _resolveComponent("CategoriesSideBar")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageTitle, { titleElement: 'Каталог' }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_CategoriesSideBar),
      _createVNode(_component_ProductList)
    ])
  ], 64))
}